import { Outlet } from 'react-router-dom'
import DashboardNav from 'components/navs/DashboardNav'

const DashboardLayout = () => {
  return (
    <div className='flex flex-col flex-1'>
      <DashboardNav />
      <div className='p-6 bg-white shadow-md border border-gray-300 border-t-0'>
        <Outlet />
      </div>
    </div>
  )
}

export default DashboardLayout
